import lightOrDark from 'library/vendor/light-or-dark'

# Make a helper for detecting darkness
export isDark = (color) ->
	if color
	then lightOrDark(color) == 'dark'
	else false
